'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _Badge = require('./components/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _CopyWrapper = require('./components/CopyWrapper');

var _CopyWrapper2 = _interopRequireDefault(_CopyWrapper);

var _Subtitle = require('./components/Subtitle');

var _Subtitle2 = _interopRequireDefault(_Subtitle);

var _SvgWrapper = require('./components/SvgWrapper');

var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# I Am Hero
The hero section to be used for the "I Am" landing pages
 */
var IAmHero = function IAmHero(_ref) {
  var imgSrc = _ref.imgSrc,
      icon = _ref.icon,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      imgSrc: imgSrc
    },
    _react2.default.createElement(
      _CopyWrapper2.default,
      null,
      _react2.default.createElement(_Badge2.default, {
        icon: icon
      }),
      _react2.default.createElement(
        _SvgWrapper2.default,
        null,
        _react2.default.createElement(_YellowLineSVG2.default, null)
      ),
      _react2.default.createElement(
        _Title2.default,
        null,
        title
      ),
      _react2.default.createElement(
        _Subtitle2.default,
        null,
        subtitle
      )
    )
  );
};

IAmHero.propTypes = {
  /** a URL for the hero image. */
  imgSrc: _propTypes2.default.string.isRequired,
  /** which icon to display in the badge. */
  icon: _propTypes2.default.string.isRequired,
  /** the title. */
  title: _propTypes2.default.string.isRequired,
  /** the subtitle. */
  subtitle: _propTypes2.default.string.isRequired
};

IAmHero.displayName = 'IAmHero';

exports.default = IAmHero;
IAmHero.__docgenInfo = {
  'description': '# I Am Hero\r\nThe hero section to be used for the "I Am" landing pages',
  'methods': [],
  'displayName': 'IAmHero',
  'props': {
    'imgSrc': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a URL for the hero image.'
    },
    'icon': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'which icon to display in the badge.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the title.'
    },
    'subtitle': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the subtitle.'
    }
  }
};